module.exports = __webpack_public_path__ + "img/peru.a3855d5b.svg";